// Generated by CoffeeScript 2.7.0
var AfterSubmitSetting;

import DropdownSelect from 'trunks/vue/admin/components/libs/dropdown_select.js';

import RichTextEditor from 'trunks/vue/admin/components/libs/richtext_editor.js';

export default AfterSubmitSetting = {
  components: {
    dropdown: DropdownSelect,
    richtextEditor: RichTextEditor
  },
  props: {
    initialAfterSubmitSetting: {
      type: Object,
      default: function() {
        return {};
      }
    },
    afterSubmitActions: {
      type: Array,
      default: function() {
        return ['default', 'show_message', 'redirect', 'show_statistication'];
      }
    }
  },
  data: function() {
    return {
      afterSubmitAction: this.initialAfterSubmitSetting.after_submit_action || _.first(this.afterSubmitActions),
      successMessage: this.initialAfterSubmitSetting.success_message || '',
      afterSubmitShowMessage: this.initialAfterSubmitSetting.after_submit_show_message || '',
      afterSubmitRedirectUrl: this.initialAfterSubmitSetting.after_submit_redirect_url || ''
    };
  },
  template: `<div class="after-submit-setting">
  <div class="tab-section">
    <h4>用户提交后行为:</h4>
    <div class="tab-section-content">
      <dropdown :optionGroups="[{ options: afterSubmitActions }]"
                :initValue='afterSubmitAction'
                @change='updateAfterSubmitAction'>
        <template slot='value-template' slot-scope='{ option }'>
          <span>{{ Skylark.Helpers.getZH_CN("form.after_submit_actions." + option) }}</span>
        </template>
        <template slot='option-template' slot-scope='{ option }'>
          <span>{{ Skylark.Helpers.getZH_CN("form.after_submit_actions." + option) }}</span>
        </template>
      </dropdown>
    </div>
    <div class="tab-section-content" v-if='afterSubmitAction === "redirect"'>
      <input type="text" v-model.trim='afterSubmitRedirectUrl' placeholder='请输入跳转链接' />
    </div>
    <div class="tab-section-content" v-show='afterSubmitAction === "show_message"'>
      <richtextEditor customClass='floated' :value='afterSubmitShowMessage' @valueChanged='updateAfterSubmitMessage' placeholder='请在此编辑' />
    </div>
  </div>
  <div class="tab-section">
    <h4>用户提交成功后的提示信息</h4>
    <div class="tab-section-content">
      <richtextEditor customClass='floated' :value='successMessage' @valueChanged='updateSuccessMessage' placeholder='请在此编辑' :menuSticky='false'></richtextEditor>
    </div>
  </div>
</div>`,
  methods: {
    getData: function() {
      return {
        after_submit_action: this.afterSubmitAction,
        success_message: this.successMessage,
        after_submit_show_message: this.afterSubmitAction === 'show_message' ? this.afterSubmitShowMessage : '',
        after_submit_redirect_url: this.afterSubmitAction === 'redirect' ? this.afterSubmitRedirectUrl : ''
      };
    },
    updateAfterSubmitMessage: function(message, delta) {
      return this.afterSubmitShowMessage = message;
    },
    updateAfterSubmitAction: function(action) {
      return this.afterSubmitAction = action;
    },
    updateSuccessMessage: function(new_message, delta) {
      return this.successMessage = new_message;
    }
  }
};
